
import { Component, Prop, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { LeavesRepositoryInterface } from '@/services/Calendar/leaves/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
  inject: [
    'leavesRepository',
  ],
})
export default class UpdateEmployeeLeavesDialog extends Vue {
  private leavesRepository!: LeavesRepositoryInterface;

  @Prop() private userId: string;

  private visible: boolean = true;
  private loading: boolean = true;

  private dateMenu: boolean = false;

  private form = {
    paidLeaves: undefined as number | undefined,
    additionalPaidLeaves: undefined as number | undefined,
    specialAdditionalPaidLeaves: undefined as number | undefined,
    prevBalance: undefined as number | undefined,
    isManager: undefined as boolean | undefined,
    canUsePaidLeaveAfter: undefined as string | undefined,
    nextYearLeaves: undefined as number | undefined,
  };


  public async created(): Promise<void> {
    const e = await this.leavesRepository.getEmployeeLeaves(this.userId);

    this.form.paidLeaves = e.paidLeaves;
    this.form.additionalPaidLeaves = e.additionalPaidLeaves;
    this.form.specialAdditionalPaidLeaves = e.specialAdditionalPaidLeaves;
    this.form.prevBalance = e.prevBalance;
    this.form.isManager = e.isManager;
    this.form.nextYearLeaves = e.nextYearLeaves;

    if (e.canUsePaidLeaveAfter) {
      this.form.canUsePaidLeaveAfter = e.canUsePaidLeaveAfter.substr(0, 10);
    }

    this.loading = false;
  }

  private buildPayload(): any {
    const p: any = {};

    if (this.form.paidLeaves !== undefined) {
      p.paidLeaves = Number(this.form.paidLeaves);
    }

    if (this.form.additionalPaidLeaves !== undefined) {
      p.additionalPaidLeaves = Number(this.form.additionalPaidLeaves);
    }

    if (this.form.specialAdditionalPaidLeaves !== undefined) {
      p.specialAdditionalPaidLeaves = Number(this.form.specialAdditionalPaidLeaves);
    }

    if (this.form.prevBalance !== undefined) {
      p.prevBalance = Number(this.form.prevBalance);
    }

    if (this.form.isManager !== undefined) {
      p.isManager = this.form.isManager;
    }

    if (this.form.nextYearLeaves !== undefined) {
      p.nextYearLeaves = Number(this.form.nextYearLeaves);
    }

    if (this.form.canUsePaidLeaveAfter) {
      p.canUsePaidLeaveAfter =
        new Date(this.form.canUsePaidLeaveAfter).toISOString();
    }

    return p;
  }

  private async save(): Promise<void> {
    try {
      const data = this.buildPayload();

      await this.leavesRepository.editEmployeeLeaves(this.userId, data);
      this.$successDialog.show('Paid leaves edited successfully!');
      this.destroyComponent();
      this.$emit('saved');
    } catch (e) {
      this.$errorDialog.show(e.response?.data);
    }
  }

  private destroyComponent(): void {
    this.visible = false;
    this.$emit('close');
  }

  private close(): void {
    this.destroyComponent();
  }
}
